<template>
  <div class="detail-affiliate-withdrawal">
    <div class="margin-top">
      <el-table
        :data="detailAffiliateWithdrawals"
        border
        style="width: 100%"
        v-loading="loading">
        <el-table-column
          prop="userName"
          :label="$t('affiliate.distributor')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="amount"
          :label="$t('affiliate.withdrawalAmount')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="realAmount"
          :label="$t('affiliate.actualAmount')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fee"
          :label="$t('affiliate.serviceFee')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="accountType"
          :label="$t('affiliate.accountType')"
          align="center">
          <template slot-scope="scope">
            {{ _account_type(scope.row.accountType) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="state"
          :label="$t('affiliate.status')"
          align="center">
          <template slot-scope="scope">
            {{ _state(scope.row.state) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="completeTime"
          :label="$t('affiliate.completeTime')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('affiliate.createTime')"
          align="center">
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { listAffiliateWithdrawal } from '@/api/affiliate/affiliateWithdrawalApi'

export default {
  name: 'DetailAffiliateWithdrawal',
  data() {
    return {
      loading: false,
      detailAffiliateWithdrawals: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      auId: ''
    }
  },
  methods: {
    loadData(params) {
      this.auId = params.auId
      this.getList()
    },
    async getList() {
      this.loading = true
      try {
        const res = await listAffiliateWithdrawal({
          auIdContain2Level: this.auId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        })
        this.detailAffiliateWithdrawals = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取提现记录列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    _state(state) {
      if (state === "0") {
        return this.$t('affiliate.applying')
      }
      if (state === "1") {
        return this.$t('affiliate.processing')
      }
      if (state === "2") {
        return this.$t('affiliate.completed')
      }
      if (state === "3") {
        return this.$t('affiliate.rejected')
      }
      return ''
    },
    _account_type(accountType) {
      if (accountType === "1") {
        return this.$t('affiliate.alipay')
      }
      if (accountType === "2") {
        return this.$t('affiliate.wechat')
      }
      if (accountType === "3") {
        return this.$t('affiliate.bankCard')
      }
      return ''
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>